import type { OrgInsightsResponse } from '@/actions/entities';
import { OrgOverviewStatistic } from './../types';
import android from './orgOverviewStatsAndroid.json';
import ios from './orgOverviewStatsiOS.json';
import allApps from './orgOverviewStatsAllApps.json';

export const generateOrgOverviewStats = (): Record<string, OrgOverviewStatistic[]> => {
    const stats: Record<string, OrgOverviewStatistic[]> = {
        'org-demo': allApps as OrgOverviewStatistic[],
        'app-apollo-ios': ios as OrgOverviewStatistic[],
        'app-apollo-android': android as OrgOverviewStatistic[],
    };
    return stats;
};

export const generateOrgOverviewInsights = (): Record<string, OrgInsightsResponse> => ({
    demo: {
        type: 'success' as OrgInsightsResponse['type'],
        description:
            'Release health is trending up: ${metric:ReleaseFrequency} increased while ${metric:FailureRate} stayed low across the selected apps.',
    },
});
